module.exports = __webpack_public_path__ + "img/05.7098cf38.jpg";